import LineIcon from '../../../../assets/images/line.svg';
import BarIcon from '../../../../assets/images/bar.svg';
import type { ChartPeriod } from '../../../../states';

export const AXIS_OPTIONS = [
  { value: 'no', label: 'No axis' },
  { value: 'y', label: 'Only Y axis' },
  { value: 'x', label: 'Only X axis' },
  { value: 'xy', label: `Both 'X' and 'Y'` },
];

export const POSITION_OPTIONS = [
  { value: 'top_right', label: 'Top right' },
  { value: 'top_left', label: 'Top left' },
  { value: 'bottom_left', label: 'Bottom left' },
  { value: 'bottom_right', label: 'Bottom right' },
];

export const BORDER_OPTIONS = [{ value: 'none', label: 'None' }];

export const TIME_PERIOD: ChartPeriod[] = [
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
];

export const CHART_TYPE_LIST = [
  {
    id: 2,
    value: 'bar',
    label: 'Bar',
    image: BarIcon,
  },
  {
    id: 1,
    value: 'line',
    label: 'Line',
    image: LineIcon,
  },
];
